/* ========================================================================
 * Slick js
 * ======================================================================== */
"use strict";

import $ from "jquery";
import "../vendor/slick";
import Toolbox from "../components/toolbox";


function getConfig() {
	const configs = {
		default: {
			arrows: true,
			draggable: true,
			focusOnSelect: false,
			speed: 300,
			infinite: true,
			variableWidth: true
		},
		fiveSlides: {
			slidesToShow: 5,
			slidesToScroll: 5,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						variableWidth: false,
						slidesToShow: 3,
						slidesToScroll: 3
					}
				},
				{
					breakpoint: 768,
					settings: {
						variableWidth: false,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		},
		fullPage: {
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: false,
			autoplay: true,
			arrows: false
		}
	};

	let config = configs.default;
	const isFullPageSlider = $(".slider").find(".col-100").length > 0;

	if (isFullPageSlider) {
		$(".slider").addClass("full-page"); // for css
		config = $.extend(config, configs.fullPage);
	}
	else {
		config = $.extend(config, configs.fiveSlides);
	}

	return config;
}

let lazySliders = [];

function init() {
	// Non-lazyloaded sliders.
	$(".slider").slick(getConfig());

	// Lazyloaded sliders.
	const lazySliderSelector = ".slider-lazy";
	lazySliders = document.querySelectorAll(lazySliderSelector);
	for (const lazySlider of lazySliders) {
		lazySlider.dataset.state = "unloaded";
	}
	if (lazySliders.length > 0) {
		addProductListLazyloaderListeners();
		checkSliderVisiblity();
	}
}


function scrollListener() {
	Toolbox.throttle(function () {
		checkSliderVisiblity();
	}, 500, "checkSliderVisiblityLazy");
}

function addProductListLazyloaderListeners() {
	window.addEventListener(
		"scroll",
		scrollListener, Toolbox.listenerOptions()
	);

	// In case page is opened to new tab and doesn't have focus immediately.
	window.addEventListener(
		"focus",
		checkSliderVisiblity, Toolbox.listenerOptions()
	);
}

function checkSliderVisiblity() {
	let allDone = true;
	for (const lazySlider of lazySliders) {
		if (lazySlider.dataset.state === "unloaded") {
			allDone = false;
			if (
				window.scrollY + window.outerHeight + 200 >
				lazySlider.offsetTop
			) {
				lazySlider.dataset.state = "done";
				try {
					$(lazySlider).slick(getConfig());
				} catch (e) {
					console.log(e);
				}
			}
		}
	}

	if (allDone) {
		window.removeEventListener(
			"scroll",
			scrollListener, Toolbox.listenerOptions()
		);
		window.removeEventListener(
			"focus",
			checkSliderVisiblity, Toolbox.listenerOptions()
		);
	}

}


export default init;

//intersport config
//{dots:!1,infinite:!0,speed:300,centerMode:!0,variableWidth:!0,slidesToScroll:1,draggable:!1,focusOnSelect:!0,arrows:!1})}
